import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { formatFinance } from "../../../../utils/formatters";

// Register the required components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ReportIncomeChart = ({
  items,
  label = "Relatório",
  showLegend = false,
}) => {
  const labels = items.map((item) => item.title || item.name);
  const data = {
    labels,
    datasets: [
      {
        label: "Total de Ganhos",
        data: items.map((item) => item.total_order_value || item.total_finance),
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: showLegend,
      },
      title: {
        display: true,
        text: label,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const item = items[tooltipItem.dataIndex];
            let label = [];
            if (item.total_order_value || item.total_finance) {
              label.push(
                `Receita Total: R$${
                  item.total_order_value || item.total_finance
                }`
              );
            }
            if (item.order_count) {
              label.push(`Quantidade de Pedidos: ${item.order_count}`);
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: (value) => formatFinance(value),
        font: {
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          autoSkip: false,
          font: {
            size: 10,
          },
        },
      },
      y: {
        ticks: {
          autoSkip: false,
          font: {
            size: 10,
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ReportIncomeChart;
